// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","botHead":"CTAHeading_botHead__0VjyI","root":"CTAHeading_root__Wvt1p"};